module.exports = __webpack_public_path__ + "img/20ne.84485aed.svg";